import { global } from "../../constants";

export const data = {
    banner: {
        background: global.banner + "contactus.webp",
        title: "联系我们",
        base: "首页",
        crumb: "联系我们",
        sendMessage: "给我们留言",
        submitNow: "立即发送",
        contactUs: "联系我们",
        name: "姓名",
        email: "电子邮件",
        phone: "电话号码",
        subject: "主题",
        message: "留言",
    }
}